import { AnnotationButton } from "components/annotations/AnnotationButton";
import { ReactNode } from "react";
import styles from "../aic.module.css";
import { classMerge } from "../utility/classMerge";
import { AitAddRowButton } from "./AitAddRowButton";
import { AitRemoveRowButton } from "./AitRemoveRowButton";
import { AitRowDeletedItemTrafficLight } from "./AitRowDeletedItemTrafficLight";
import { AitRowGroupDeletedItemTrafficLight } from "./AitRowGroupDeletedItemTrafficLight";
import { AitLocationHeaderRow, AitTablePosition } from "./functions/interface";
import { trGetPositionFromLocation } from "./functions/trGetPositionFromLocation";
import { useTableContext } from "./TableContextProvider";

interface AitHeaderRowLastCellProps {
  location: AitLocationHeaderRow;
}

/**
 * Render the last cell for a header row with row controls and annotations.
 *
 * @param props - Component props
 * @param props.location - The header row location
 */
export const AitHeaderRowLastCell = ({ location }: AitHeaderRowLastCellProps): ReactNode => {
  const { state } = useTableContext();
  const thisRow = trGetPositionFromLocation(state, location, true).data;

  return (
    <td
      className={styles.aitCell}
      width="50px"
    >
      {location.row === 0 && !location.isRepeat && (
        <AitRowGroupDeletedItemTrafficLight
          location={{
            position: AitTablePosition.header,
            tableSection: location.tableSection,
            rowGroup: location.rowGroup,
            rowGroupId: location.rowGroupId,
          }}
        />
      )}
      <AitRowDeletedItemTrafficLight location={location} />
      <div className={classMerge([styles.flexRowStart, styles.aitAieHolder])}>
        <div className={styles.aitRowButtons}>
          <AitAddRowButton location={location} />
          <AitRemoveRowButton location={location} />
        </div>
        <AnnotationButton
          buttonId={`${location.position}-row-${location.rowId}-annotation`}
          annotationType="Row"
          annotationLocation={location}
          existingAnnotation={thisRow?.annotation}
          hidden={state?.tlfViewMode.value !== "ANNOTATIONS"}
          showPreview={state?.tlfViewMode.value === "ANNOTATIONS"}
        />
      </div>
    </td>
  );
};

AitHeaderRowLastCell.displayName = "AitHeaderRowLastCell";
